import request from '@/common/utils/request'

export default {
    login: (code, inviter) => {
        // 微信登录&注册
        return request({
            url: '/api/login/',
            method: 'POST',
            data: {
                code,
                inviter
            }
        })
    },
    getAuthUrl(path, inviter='') {
        const redirectUrl = process.env.NODE_ENV === 'production' ? 'http://www.aiata.cn/login' : 'http://127.0.0.1:9000/login'
        return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc7e5930a66b17e8c&redirect_uri=' + encodeURIComponent(redirectUrl) + '&response_type=code&scope=snsapi_userinfo&state=' + encodeURIComponent(path + '||' + inviter) + '#wechat_redirect'
    },
    getMyInfo() {
        // 获取我的头像和名称
        return request({
            url: `/api/my/info/`,
            method: 'GET',
        })
    },
    getInviterInfo(inviter, mid) {
        // 获取邀请者头像和名称
        return request({
            url: `/api/i/${inviter}/`,
            method: 'GET',
            params: {
                mid
            }
        })
    },
    getMyTeamScore() {
        // 团队积分情况（团队包含自己和上级和直属下级的积分情况）
        return request({
            url: `/api/my/team/`,
            method: 'GET',
        })
    },
    getRank() {
        // 积分排行情况
        return request({
            url: `/api/score/rank/`,
            method: 'GET',
        })
    },
    getMission(){
        // 任务列表
        return request({
            url: `/api/my/mission/`,
            method: 'GET',
        })
    },
    getPointHistory(){
        // 任务列表
        return request({
            url: `/api/point_history/`,
            method: 'GET',
        })
    },
    getBountyHistory(){
        // 任务列表
        return request({
            url: `/api/bounty_history/`,
            method: 'GET',
        })
    },
    setAvatar(avatar) {
        // 设置头像
        return request({
            url: `/api/my/avatar/`,
            method: 'POST',
            data: {
                avatar
            }
        })
    },
    setName(name) {
        // 设置名称
        return request({
            url: `/api/my/name/`,
            method: 'POST',
            data: {
                name
            }
        })
    },
    getMyScore() {
        // 查询当前积分
        return request({
            url: `/api/my/score/`,
            method: 'GET'
        })
    },
    unlockCycle(cid, use_point) {
        // 解锁周期
        return request({
            url: `/api/unlock/cycle/${cid}/`,
            method: 'POST',
            data: {
                use_point
            }
        })
    },
    buyPoint(amount) {
        // 购买积分
        return request({
            url: `/api/buy/point/${amount}/`,
            method: 'POST'
        })
    },
    unlockSuspendCycle(cid) {
        // 解锁超时锁定的周期
        return request({
            url: `/api/unlock/suspend/cycle/${cid}/`,
            method: 'POST'
        })
    },
    resetSuspendCycle(cid) {
        // 重置超时锁定的周期
        return request({
            url: `/api/reset/suspend/cycle/${cid}/`,
            method: 'POST'
        })
    },
}
